import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import ProductSpecfication from "component/ProductSpecification/ProductSpecification";
import "./ProductDetail.css";
import styled from "styled-components";
import { apiHandler } from "api";
import { endpoint } from "api/endpoint";
// import { Button, Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';
import { Modal, Button } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
// import ReactThreeFbxViewer from "react-three-fbx-viewer";
import {
  saveDeatailInternationalHeader,
  saveInternationalHeader,
} from "features/homepage/homeDataSlice";
import { useDispatch } from "react-redux";
import Breadcrew from "component/Breadcrumb/BreadCrumb";
import ProductImages from "component/ProductImage/ProductImages";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { isElementInViewport } from "utils";
const RelatedProducts = React.lazy(() => import("./RelatedProducts"));
// var FBXinHTML = require('../../asset/FABInHtml.html');
// let fbxUrl = "./asd.fbx";

const ProductDetail = (props) => {
  const dispatch = useDispatch();
  // const [border, setBorder] = useState(0);
  // const [selectedindex, setSelectedIndex] = useState("");
  const [productList, setProductList] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [breadName, setBreadName] = useState("");
  // const [subcatbreadurl, setSubCatBreadUrl] = useState("");
  const [homeUrl, setHomeUrl] = useState(true);
  // const [indeximg, setIndeximg] = useState("0");
  const [imageList, setImageList] = useState([]);
  const [hide3dImage, setHide3dImage] = useState(false);
  const [loader, setLoader] = useState(false);
  const [parmaUrl, setParamUrl] = useState("");
  // console.log('.......Image List ', imageList);
  const histroy = useHistory();
  const [catgoryName, setCatgoryName] = useState({});
  const [subCatgoryName, setsubCatgoryName] = useState({});
  const [breadhomeUrl, setBreadHomeurl] = useState("");
  const [show, setShow] = useState(false);
  const [configProduct, setConfigProduct] = useState(false);
  const [productBanner, setProductBanner] = useState("");
  const [FbxURL, setFbxURL] = useState("");
  const [FbxUrlendpoint, setFbxUrlendpoint] = useState("");
  const handleClose = async () => {
    setShow(false);
    window.location.reload();
  };
  const getcolorsImages = (item) => {
    setImageList(item.images);
  };
  const [modal, setModal] = useState(false);
  const params = useParams();

  useEffect(() => {
    const url = params && params.url_key ? params.url_key : props.urlKey;
    if (parmaUrl !== url) {
      getProuctDetails();
    }
  }, [params, props.urlKey]);
  const getProuctDetails = async () => {
    setLoader(true);
    const url = params && params.url_key ? params.url_key : props.urlKey;
    setParamUrl(url);
    let productname = url;
    // console.log('productid', productname);
    const result = await apiHandler({
      url: endpoint.PRODUCT_DETAIL + productname,
    });
    if (result.data && result.data.length !== 0 && result.data[0].is_active) {
      result.data &&
        result.data.forEach((item) => {
          if (item.mf_type === "indian") {
            dispatch(saveDeatailInternationalHeader(false));
            dispatch(saveInternationalHeader(true));
            setHomeUrl(true);
            // document.title = `Buy ${item.name} from Johnson Bathrooms`;
          } else {
            dispatch(saveDeatailInternationalHeader(true));
            dispatch(saveInternationalHeader(false));
            setHomeUrl(false);
            // document.title = `Buy ${item.name} from Johnson Bathrooms`;
          }
        });
      setProductDetails(result.data);
      result.data &&
        result.data.forEach((item) => {
          if (item["3d_image"] === "") {
            setHide3dImage(false);
          } else {
            setHide3dImage(true);
            setFbxUrlendpoint(item["3d_image"]);
          }
        });
      result.data &&
        result.data.forEach((item) => {
          if (item.configurable_options && item.child_products) {
            setConfigProduct(true);
          } else {
            setConfigProduct(false);
          }
        });
      result.data &&
        result.data.forEach((item) => {
          if (item.product_banner) {
            setProductBanner(item.product_banner);
          } else {
            setProductBanner("");
          }
        });
    } else {
      setProductDetails([]);
      histroy.push("/error-404");
      console.log("clicked");
    }
    // console.log('........selescted product', result.data);
    setLoader(false);

    if (result.data.length > 0) {
      const product = result.data[0];
      setBreadName(product.name);
      setProductList(product.related_products);
      parseProductCategory(product.breadcrumbs);
    }
  };
  useEffect(() => {
    if (homeUrl) {
      setBreadHomeurl("/");
    } else {
      setBreadHomeurl("/international");
    }
  }, [productDetails]);

  useEffect(() => {
    setFbxURL(
      "https://backend.johnsonbathrooms.in/media/FABInHtml.html?fileurl=https://backend.johnsonbathrooms.in" +
        FbxUrlendpoint
    );
  }, [FbxUrlendpoint]);

  const parseProductCategory = (Breaddata) => {
    // const objectLength = Object.keys(Breaddata).length;
    // console.log('.....Lenght', objectLength);
    // console.log('ARAAAAAAAAAAAAAAAAAAaa', Object.values(Breaddata));
    const catgoryName = Object.values(Breaddata).slice(-2, -1)[0];
    // console.log('CatgoryName', catgoryName);
    const subCatgoryName = Object.values(Breaddata).slice(-1)[0];
    // console.log('SubCatgoryName', subCatgoryName);
    setCatgoryName(catgoryName);
    setsubCatgoryName(subCatgoryName);
  };

  // console.log('............Catgoryname', catgoryName, subCatgoryName);
  const handleOpen3d = (i) => {
    setShow(i);
  };
  // const setDisplayImage = async (index) => {
  //   setIndeximg(index);
  //   await setSelectedIndex(index);
  //   await setBorder(index);
  //   setProductDetails([...productDetails]);
  // };
  // console.log('....cative image index ', border);
  const getBreadCrumbData = () => {
    let list = [];
    const catKey =
      catgoryName && catgoryName.url_key ? catgoryName.url_key : "";
    const subCatKey =
      subCatgoryName && subCatgoryName.url_key ? subCatgoryName.url_key : "";
    list.push({ name: "Home", url: breadhomeUrl });
    // list.push({ name: 'Products', url: '/' });
    list.push({
      name: catgoryName && catgoryName.title,
      url: "/products/" + catKey,
    });
    list.push({
      name: subCatgoryName && subCatgoryName.title,
      url: "/products/" + catKey + "/" + subCatKey,
    });
    list.push({ name: breadName, url: null });
    return list;
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollTop =
  //       window.pageYOffset !== undefined
  //         ? window.pageYOffset
  //         : document.body.scrollTop;
  //     if (scrollTop > 100) {
  //       setShowRelatedProducts(true);
  //       window.removeEventListener("scroll", handleScroll);
  //     }
  //   };

  //   const bannerNode = document.querySelector(".banner");
  //   if (
  //     (bannerNode && !isElementInViewport(bannerNode)) ||
  //     window.innerHeight > 1600
  //   ) {
  //     setShowRelatedProducts(true);
  //   } else window.addEventListener("scroll", handleScroll);
  // }, []);

  return (
    <div className="featurepage">
      <div className="banner product-detail-banner">
        <img
          src={
            productBanner || "/assets/images/Default_ProductListing_Banner.jpg"
          }
          alt=""
          width={1920}
          height={450}
          fetchpriority="high"
        />
        <Breadcrew data={getBreadCrumbData()} />
      </div>
      <div className="container">
        <div className="product-single-container product-single-default pt-5">
          {productDetails &&
            productDetails.slice(0, 1).map((item, index) => (
              <div className="row" key={index}>
                <div className="col-lg-5 col-md-6 product-single-gallery product-detail-gallery">
                  <div
                  // className='product-slider-container'
                  // style={{ backgroundColor: '#FFF' }}
                  >
                    {/* <div className='label-group'> */}

                    <div className="">
                      {/* {item['3d_image'] != '' && (
												<div className='product-label label-hot pointerimg'>
													<img src={threedIcon} onClick={handleShow} width={31} height={31} loading='lazy' />
												</div>
											)} */}
                      {/* Modal Body for 3D Effect */}
                      <Modal
                        className="requestforprice"
                        show={show}
                        onHide={handleClose}
                      >
                        <Modal.Header>
                          <Button variant="secondary" onClick={handleClose}>
                            <AiFillCloseCircle />
                          </Button>
                        </Modal.Header>
                        <Modal.Body>
                          {/* <div className='modal3Dimg'>
														<ReactThreeFbxViewer
															cameraPosition={cameraPosition}
															url={
																item['3d_image']
																	? endpoint.API_BASE_URL + item['3d_image']
																	: fbxUrl
															}
															angle='70'
															backgroundColor='#a9a9a9'
														/>
													</div> */}
                          <iframe
                            src={FbxURL}
                            scrolling="no"
                            border="0px"
                          ></iframe>
                        </Modal.Body>
                      </Modal>
                      <ProductImages
                        flag3dImage={hide3dImage}
                        three3d={handleOpen3d}
                        listofimage={configProduct ? imageList : item.images}
                        imageALT={item.image_alt}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-7 col-md-6 product-single-details product-details">
                  <LazyLoadComponent>
                    <ProductSpecfication
                      available_color={item.available_color}
                      productname={item.name}
                      price={item.price}
                      code={item.sku || ""}
                      StyleFeatures={item.short_description || ""}
                      productprice={
                        (item && Number(item.price).toFixed(2)) || ""
                      }
                      isNew={item.is_new}
                      productdiscription={item.description || ""}
                      productwarranty={item.product_warranty_text || ""}
                      productId={item.id}
                      producttechnicaldrawing={
                        item.technical_details_text || ""
                      }
                      productimages={item.images}
                      Breaddata={item.breadcrumbs}
                      configurable_Options={item.configurable_options}
                      child_products={item.child_products}
                      colors_images={getcolorsImages}
                      config_Flag={configProduct}
                      germFreeLogo={item.germfree_non_germ_free}
                      internationalLogo={item.international_non_internationa}
                      iconchrome_plated={item.chrome_plated}
                      icongerm_free={item.germ_free}
                      iconhigh_tech_cartridges={item.high_tech_cartridges}
                      icondual_flush={item.dual_flush}
                      iconslim_seat_cover={item.slim_seat_cover}
                      iconsoft_close={item.soft_close}
                      iconsyphonic_flushing={item.syphonic_flushing}
                      type={item.type}
                      range={item.range}
                      size={item.size}
                      finish={item.finish}
                      color={item.color}
                      imageALT={item.image_alt}
                      featuredImages={item.featured_images}
                    />
                  </LazyLoadComponent>
                </div>
                {/* {showRelatedProducts && (
                  <React.Suspense> */}
                <RelatedProducts productList={productList} />
                {/* </React.Suspense>
                )} */}
              </div>
            ))}
        </div>
      </div>
      {loader && (
        <div className="loading-overlay">
          <div className="bounce-loader">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      )}
    </div>
  );
};
const Placeholder = styled.div`
  height: 30px;
`;

export default ProductDetail;
